import { indexItems } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-500/15 text-primary-400 border border-primary-500/20 mb-3">
            <i className="ri-folder-open-line mr-1"></i>分类浏览
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            专题合集
          </h2>
          <p className="mt-2 text-sm text-foreground-500">按类型发现你感兴趣的高清影视内容</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4">
          {indexItems.map((item) => (
            <a
              key={item.title}
              href="#index"
              className="group p-5 rounded-xl bg-background-100 border border-background-200/50 hover:border-primary-500/30 hover:bg-background-200/50 transition-all duration-200 cursor-pointer flex flex-col items-center text-center"
            >
              <span className="w-12 h-12 rounded-xl bg-primary-500/10 flex items-center justify-center mb-3 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${item.icon} text-xl text-primary-400`}></i>
              </span>
              <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-400 transition-colors whitespace-nowrap">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1 line-clamp-1">{item.desc}</p>
              <span className="mt-2 text-xs font-medium text-foreground-600 bg-background-200/50 px-2.5 py-0.5 rounded-full">
                {item.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}